import type { Theme } from '@mui/material';

export const styles = {
  content: (theme: Theme) => ({
    backgroundColor: theme.colors.white,
    p: 2,
  }),
};
